"use client";

import { useEffect, useRef, useState } from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourDreamApplianceAwaits() {
  const [scrollY, setScrollY] = useState(0);
  const [flicker, setFlicker] = useState(1);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const flickerInterval = setInterval(() => {
      setFlicker(0.92 + Math.random() * 0.08);
    }, 150);
    return () => clearInterval(flickerInterval);
  }, [isVisible]);
  const parallaxOffset = scrollY * 0.4;
  return <section className="relative w-full min-h-screen overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 w-full h-full bg-cover bg-center" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1418843/img/hero_kitchen_appliances.png)",
      transform: `translateY(${parallaxOffset}px)`,
      willChange: "transform"
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none transition-opacity duration-[var(--duration-fast)]" style={{
      background: "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.08) 0%, transparent 60%)",
      opacity: flicker
    }} />

      {}
      <div className="absolute inset-0 bg-dark-background/70" />

      {}
      <div ref={contentRef} className="relative z-10 flex flex-col items-start justify-center min-h-screen px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto">
        <h1 className={`
            font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold
            text-foreground-dark leading-tight mb-6
            transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
            ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}
          `}>
          Your Dream Appliance Awaits
        </h1>

        <p className={`
            text-foreground-dark/90 text-lg sm:text-xl md:text-2xl mb-10 max-w-2xl
            transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)] delay-100
            ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}
          `}>
          Unbeatable prices on top appliances. Fast delivery to your door.
          Discover quality and savings at Smart Buy Appliances.
        </p>

        <div className={`
            flex flex-col sm:flex-row gap-4
            transition-all duration-[var(--duration-slow)] ease-[var(--ease-spring)] delay-200
            ${isVisible ? "opacity-100 scale-100" : "opacity-0 scale-90"}
          `}>
          <Button asChild size="lg" className="btn-primary text-base sm:text-lg px-8 py-4">
            
          </Button>

          <Button asChild variant="outline" size="lg" className="bg-background/10 backdrop-blur-sm border-foreground-dark/40 text-foreground-dark hover:bg-background/20 text-base sm:text-lg px-8 py-4">
            <Link to="tel:9197030041">
              <Phone className="size-5" />
              Call Now
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}